<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Check Pattern</strong> <small>Set the user pattern to be added to the scan user's site.</small>
            <span class="float-right">{{model.created_at | datetime}}</span>
          </div>
          <b-row>
            <b-col md="4">
              <b-form-group>
            <label for="is_use_true">Alive_Status</label><br/>
            <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
          </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_level" v-b-tooltip.hover title="Sets the risk level for the pattern.">Level</label>
                <b-form-select id="ph_level" v-model="model.level" :disabled="lock">
                  <option value="H">Danger</option>
                  <option value="W">Warning</option>
                  <option value="N">Caution</option>
                  <option value="S">Suspicion</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_type" v-b-tooltip.hover title="It's how the pattern works. URL (Link retention investigation), String (Inclusion of strings), Regex (Scan content with regular expression), MD5 (Comparison of MD5 hash values for content)">Type</label>
                <b-form-select id="ph_type" v-model="model.type" :disabled="lock">
                  <option value="U">URL</option>
                  <option value="S">String</option>
                  <option value="R">Regex</option>
                  <option value="M">MD5</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_code" v-b-tooltip.hover title="Code to be retrieved from the page.">Code</label>
                <b-form-input :state="model.type == 'R' ? regex_valid(model.code) : (model.code && model.code.length > 0) || false" md=5 type="text" id="ph_code" v-model="model.code" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="lock">
            <b-button size="sm" variant="warning" @click="edit"> Edit </b-button>
            <b-button size="sm" variant="danger" @click="confirm = true"> Remove </b-button>
          </template>
          <template v-else>
            <b-button size="sm" variant="success" @click="save"> Save </b-button>
            <b-button size="sm" variant="secondary" @click="cancel"> Cancel </b-button>
          </template>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="Pattern Remove" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      This operation cannot be reversed.
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import { Switch as cSwitch } from '@coreui/vue';

export default {
  components: {
    cSwitch,
  },
  data : () => {
    return {
      confirm: false,
      add: false,
      lock: true,
      model : { group: {} },
    }
  },
  methods: {
    regex_valid: (c, f = '') => {
      if(!c) { return false }
      try { new RegExp(c, f); return true } catch(e) { return false }
    },
    cancel() { this.$router.replace({ name: 'wmds_upattern', params: { id: this.model.id }}) },
    edit() { this.$router.replace({ name: 'wmds_upattern', params: { id: this.model.id, tag: 'edit' }}) },
    async remove() {
      try{
        let rs = await Api.Manager_Call('wmds.user.pattern', 'delete', { id :this.model.id })
        if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list(); this.$emit("refresh");
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    list() { this.$router.push({ name: 'wmds_upattern'}); this.$emit('refresh'); },
    async save() {
      if(!(this.model.code || '').trim()) { return this.$toastr.e('Pattern is Require'); }
      if(!this.regex_valid(this.model.code)) { return this.$toastr.e("No vaild expression"); }

      try {

        let rs = await Api.Manager_Call('wmds.user.pattern', this.model.id ? 'update' : 'insert', this.model);
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name); this.$emit('refresh'); this.cancel();
        } else {
          this.$toastr.e('Save', "failed"); this.$emit('refresh'); this.cancel();
        }

      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('pattern.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = { is_alive: true, level: 'W', type: 'U' }; return; }
      try{
        this.add = false;
        this.lock = (tag !== 'edit');
        let rs = await Api.Manager_Call('wmds.user.pattern', 'detail', { id : id })
        this.model = Object.assign({ group: {} }, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('pattern.detail.vue', 'created'); },
  destroyed() { console.log('pattern.detail.vue', 'destroyed'); },
  mounted() {
    console.log('pattern.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
